import React, { useEffect } from 'react';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button as Btn, Table, TableProps } from 'react-bootstrap';

export type selectableColumnIndexProps = 1 | 2 | 3 | 4 | -1;

export type tableDataProps = {
  headers: string[];
  rows: Array<string[]>;
};

export type customGenericTableProps = TableProps &
  React.PropsWithChildren<{
    selectedColumnIndex?: selectableColumnIndexProps;
    selectedRowIndex?: number;
    selectedCellPosition?: Array<number>;
    headerTitle?: String;
    downloadButton?: String;
    tableData: tableDataProps;
    className?: string;
  }>;

const GenericTable = ({
  selectedColumnIndex,
  selectedRowIndex,
  selectedCellPosition,
  headerTitle,
  downloadButton,
  tableData,
  className,
}: customGenericTableProps) => {
  const [tableDataStored, setTableDataStored] = React.useState<tableDataProps>();

  const button = () => (
    <span className='ps-4'>
      <Btn
        style={{boxShadow: 'none', width: '18px', height: '18px'}}
        size='sm'
        variant={'icon-default'}
        className={`btn-icon`}
      >
        <span><FontAwesomeIcon color='blue' icon={light('file-download')} /></span>
      </Btn>
    </span>
  );

  useEffect(() => {
    if (tableData) {
      setTableDataStored(tableData);
    }
  }, [tableDataStored, tableData]);

  return (
    <>      
      {tableDataStored ? (
        <Table borderless hover size="lg" className="custom-generic-table">
        <thead>
          {headerTitle && <tr className={(headerTitle && 'border-separator')}>
            <th></th>
            {tableData['headers'].length > 2 && <th 
              className='grey'
              colSpan={tableData['headers'].length-1}
            >
              {headerTitle}
            </th>}
          </tr>}
          <tr>
            {tableData['headers'].map((header, index) => (
              <th
                className={
                  `${index === selectedColumnIndex ? 'selected-column' : ''}`
                }
                key={index}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData['rows']?.map((row, i) => (
            <tr className={selectedRowIndex === i ? 'selected-row' : ''}>
              {row?.map((cell, index) => (
                <td
                  className={`
                    ${(selectedCellPosition?.[1] === index && selectedCellPosition?.[0] === i) || index === selectedColumnIndex ? 'selected-column ' : ' '}
                    ${className ? className : ''}
                  `}
                  key={index}
                >
                  {cell}
                  {!index && i < tableData['rows'].length-1 && downloadButton && button()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
      ) : (
        <h1>NO DATA</h1>
      )}
    </>
  );
};

export default GenericTable;
